export const passwordOk = (pw) => pw.length >= 8 && /[A-Za-z]/.test(pw) && /\d/.test(pw);

export default function PasswordStrength({ password }) {
  if (!password) return null;
  const checks = [
    { ok: password.length >= 8, label: "8+ characters" },
    { ok: /[A-Za-z]/.test(password), label: "a letter" },
    { ok: /\d/.test(password), label: "a number" },
  ];
  const score = checks.filter((c) => c.ok).length + (/[^A-Za-z0-9]/.test(password) && password.length >= 12 ? 1 : 0);
  const colors = ["bg-[#FF5C5C]", "bg-[#FF5C5C]", "bg-[#FFC857]", "bg-[#00E676]", "bg-[#00E676]"];
  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={`h-1 flex-1 rounded-full transition-colors ${i < score ? colors[score] : "bg-[#282C30]"}`} />
        ))}
      </div>
      <div className="mt-1.5 flex flex-wrap gap-x-3 gap-y-0.5 font-mono text-[10px] uppercase tracking-widest">
        {checks.map((c) => (
          <span key={c.label} className={c.ok ? "text-[#00E676]" : "text-[#606872]"}>{c.ok ? "✓" : "○"} {c.label}</span>
        ))}
      </div>
    </div>
  );
}
